module.exports = __webpack_public_path__ + "img/menu_cross.ef824eac.svg";